import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import ButtonSuccess from "components/Buttons/ButtonSuccess";
import SettingsBackLink from "components/Accounts/Settings/SettingsBackLink";
import { UNSUBSCRIBE_USER, GET_BILLING_DATA } from "@ugg/shared/api/graphql/queries";
import FeedbackForm from "components/Masthead/Feedback/FeedbackForm";
import { HeaderBullet } from "@ugg/shared/components/common/HeaderBullet";
import { AppRoutes } from "@ugg/shared/routes/app-routes";

interface Subscription {
  isBraintree?: boolean | null;
}

interface BillingDataResponse {
  getBillingData?: {
    subscription?: Subscription | null;
  } | null;
}

interface CancelBoostSubscriptionProps {
  setSettingsNotification: (value: boolean) => void;
}

const CancelBoostSubscription: React.FC<CancelBoostSubscriptionProps> = ({ setSettingsNotification }) => {
  const history = useHistory();

  // Fetch billing data to check if user is on Braintree
  const { data: billingData, loading: billingLoading } = useQuery<BillingDataResponse>(GET_BILLING_DATA);
  const isBraintree = billingData?.getBillingData?.subscription?.isBraintree;

  const [feedbackState, setFeedbackPopup] = useState(false);
  const toggleFeedbackPopup = () => {
    setFeedbackPopup(!feedbackState);
  };

  const [unsubscribeUser, { loading: unsubscribeLoading }] = useMutation(UNSUBSCRIBE_USER, {
    onCompleted: () => {
      history.push(AppRoutes.SETTINGS_BOOST);
      setSettingsNotification(true);
    },
  });

  if (billingLoading) {
    return (
      <div className="settings-route-page settings_premium settings_cancel-plan">
        <div className="spinthatshit-loader">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="settings-route-page settings_premium settings_cancel-plan">
      <SettingsBackLink goBack />
      <div className="settings-section">
        <div className="section-content cancel-plan">
          <HeaderBullet className="mb-[24px]">Cancel Subscription</HeaderBullet>
          <div className="cancel-plan_header">We’re sorry to see you go!</div>
          <div className="cancel-notes">
            <div className="cancel-notes_header">Please note:</div>
            <ul>
              <li>You will not receive a refund for your remaining purchased subscription time.</li>
              {isBraintree === true ? (
                <li>You will lose remaining trial time. BOOST features will be unaccessible.</li>
              ) : (
                <li>You must cancel any active subscription before deleting your account.</li>
              )}
              <li>
                If you are having issues canceling, please email us at{" "}
                <a className="underline" href="mailto:support@u.gg">
                  support@u.gg
                </a>{" "}
                or contact us{" "}
                <strong style={{ cursor: "pointer", color: "white" }} onClick={toggleFeedbackPopup}>
                  here
                </strong>
                .
              </li>
            </ul>
          </div>
          <ButtonSuccess
            className="save-settings-btn btn-light-blue cancel-btn"
            label="Cancel Subscription"
            isLoading={unsubscribeLoading}
            onClick={unsubscribeUser}
          />
        </div>
      </div>
      {feedbackState && <FeedbackForm toggleFeedbackPopup={toggleFeedbackPopup} />}
    </div>
  );
};

export default CancelBoostSubscription;
